<template>
  <div class="user-info clearfix">
    <div class="user-img"><img :src="imgSrc"/></div>
    <div class="user-name">{{userName}}</div>
    <div class="topic-time">{{topicTime}}</div>
  </div>
</template>

<script>
export default {
  name: "userInfoBar",
  props:{
    userImg: String,
    userName: String,
    topicTime: String
  },
  computed:{
    imgSrc:function (){
      if (this.userImg == undefined){
        return './static/image/head.png';
      }else {
        return this.userImg;
      }
    }
  }
}
</script>

<style scoped>
.user-info{
  height: 50px;
  padding-left: 15px;
}

.user-info .user-img{
  float: left;
}

.user-img img{
  padding-top: 6px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.user-info  .user-name{
  padding-top: 17px;
  float: left;
  margin-left: 10px;
}
.user-info  .topic-time{
  padding-top: 17px;
  float: right;
  padding-right: 10px;
  font-size: 12px;
  color: #666;
}

</style>
